import React, { Component, createRef } from 'react';
import { withStyles, TextField, Button, Container, Select, FormControl, InputLabel, MenuItem } from '@material-ui/core';
import { connect } from 'react-redux';
import { Dispatch } from 'redux'; 
import {  ADD_USER,  AUTHORIZE_USER,  UPDATE_USER } from '../../core/handlers.actions';

const styles = (theme: any) => ({
    root: { '& .MuiTextField-root': { margin: theme.spacing(1), width: '100%' } },
    editBox: { borderTop: '2px solid #f50057', borderLeft: '2px solid #f50057', borderRight: '2px solid #f50057' },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        width: '100%',
        marginBottom: 30
    },
    trixEditor: {
        marginBottom: 30,
        minWidth: 120,
        width: '100%',
    },
    formControlSelect: {
        margin: theme.spacing(1),
        minWidth: 120,
        width: '100%'
      },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
});

interface Props {
    classes: any;
    addUser: (data: any) => void;
    updateUser: (data: any) => void;
    edit: boolean;
    current: any;
    authorized?:boolean;
    action: () => void;
    authorizeUser: (data:any) => void;
}

interface State {
    firstName: string | null,
    lastName: string | null,
    username: string | null,
    email: string | null,
    role: string | null,
    title: string | null
    isAccountActive: boolean | null,
    _id: string | null;
    editing: boolean;
    error: boolean;
    password: string | null;
    authorized_email: string;
    passwordConfirm: string | null;
}

class UserForm extends Component<Props, State> {
    state: State = { firstName: '', lastName: '', username: '', email: '', role: '', title: '', isAccountActive: false, _id: '', editing: false, error: false, password: '', passwordConfirm: '', authorized_email: ''};
    editor = createRef();
    constructor(props: Props) {
        super(props);
        this.validateForm = this.validateForm.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.submit = this.submit.bind(this);
        this.update = this.update.bind(this);
        this.cancel = this.cancel.bind(this);
        this.authorizeUser = this.authorizeUser.bind(this);
    }


    public componentDidMount() {
        const { edit, current } = this.props;
        const { editing } = this.state;
        
        if (edit && !editing) {
            this.setState({ 
                ...this.state, 
                _id: current?._id, 
                firstName: current?.firstName, 
                lastName: current?.lastName, 
                username: current?.username, 
                email: current?.email, 
                role: current?.role, 
                title: current?.title,
                editing: true, 
                password: current?.password,
                isAccountActive: current?.isAccountActive
            });
        }
    }

    public inputChangeHandler(e: any) {
        const { name, value } = e.target;
        if (name === 'name') return this.setState({ ...this.state, [name]: value });
        if (name === 'isAccountActive') return this.setState({...this.state, [name]: value === 0? false: true});
        return this.setState({ ...this.state, [name]: value });
    }

    public validateForm() {
        const { firstName, lastName, username, email, role, title} = this.state;
        return firstName !== '' && firstName !== null &&
                lastName !== '' && lastName !== null &&
                username !== '' && username !== null &&
                email !== '' && email !== null &&
                role !== '' && role !== null &&
                title !== '' && title !== null;
    }

    public submit() {
        const { addUser, action } = this.props;
        const { firstName, lastName, username, email, role, title, password, isAccountActive } = this.state;
        if (!this.validateForm()) return this.setState({ ...this.state, error: true });
        addUser({ firstName, lastName, username, email, role, title, password, isAccountActive} as any);
        this.setState({ ...this.state, firstName: '', lastName: '', username: '', email: '', role: '', title: '', error: false , password: '', authorized_email: '', isAccountActive: false});
        action();
    }

    public authorizeUser(){
        const {authorizeUser, action} = this.props;
        const {authorized_email} = this.state;
        if(authorized_email === '') return this.setState({...this.state, error: true});
        authorizeUser({email: authorized_email});
        this.setState({...this.state, authorized_email: ''});
        action();
    }

    public update() {
        const { updateUser, action } = this.props;
        const { _id, firstName, lastName, username, email, role, title, isAccountActive } = this.state;
        if (!this.validateForm()) return this.setState({ ...this.state, error: true });
        updateUser({ _id, firstName, lastName, username, email, role, title, isAccountActive } as any);
        this.setState({ ...this.state, firstName: '', lastName: '', username: '', role: '', title: '', error: false, _id: '', editing: false, password: '', passwordConfirm: '', authorized_email: '', isAccountActive: false});
        action();
    }

    public cancel() {
        const { action } = this.props;
        this.setState({ ...this.state, firstName: '', lastName: '', username: '', email: '', role: '', title: '', error: false, _id: '', editing: false, password: '', authorized_email: '', passwordConfirm: ''});
        action();
    }

    public render() {
        const { classes, current, authorized } = this.props;
        const { firstName, lastName, username, email, role, title, error, password, passwordConfirm, authorized_email, isAccountActive } = this.state;
        const accountStatusSelector = isAccountActive ? 1: 0;
           
        return (
            <form className={classes.root} noValidate autoComplete="off">               
                {authorized? 
                    <Container>
                        <TextField error={error} required name="authorized_email" label="PanCAN Email" value={authorized_email ||''} onChange={this.inputChangeHandler} />
                        <div><Button variant="contained" color="primary" onClick={this.authorizeUser}>Authorize SSO User</Button>&nbsp;&nbsp;<Button variant="contained" color="secondary" onClick={this.cancel}>Cancel</Button></div>
                    </Container>
                :
                <div>
                    {current ? <h2>Update User</h2> : <h2>Add  User</h2>}
                    <Container>
                        <TextField error={error} required name="firstName" label="First Name" value={firstName ||''} onChange={this.inputChangeHandler} />
                        <TextField error={error} required name="lastName" label="Last Name" value={lastName ||''} onChange={this.inputChangeHandler} />
                        <TextField error={error} required name="username" label="Username" value={username ||''} onChange={this.inputChangeHandler} />
                        {!current ?
                        <>
                            <TextField type="password" error={error} required name="password" label="Password" value={password || ''} onChange={this.inputChangeHandler} />
                            <TextField type="password" error={error} required name="passwordConfirm" label="Confirm password" value={passwordConfirm || ''} onChange={this.inputChangeHandler} />
                        </>
                        : null
                        }
                        <TextField error={error} type='email' required name="email" label="Email" value={email ||''} onChange={this.inputChangeHandler} />
                        <TextField error={error} required name="role" label="Role" value={role ||''} onChange={this.inputChangeHandler} />
                        <TextField error={error} required name="title" label="Title" value={title||''} onChange={this.inputChangeHandler} />   
                        {current?
                            <FormControl className={classes.formControlSelect}>
                            <InputLabel>Account Status</InputLabel>
                            <Select onChange={this.inputChangeHandler} name="isAccountActive" value={accountStatusSelector || 0}>
                                <MenuItem value={1}>Active</MenuItem>
                                <MenuItem value={0}>Inactive</MenuItem>
                            </Select>
                        </FormControl>
                        :null}
                        
                        {current ? 
                            <div><Button variant="contained" color="primary" onClick={this.update}>Update User</Button>&nbsp;&nbsp;<Button variant="contained" color="secondary" onClick={this.cancel}>Cancel</Button></div> 
                        : 
                            <div><Button variant="contained" color="primary" onClick={this.submit}>Add User</Button>&nbsp;&nbsp;<Button variant="contained" color="secondary" onClick={this.cancel}>Cancel</Button></div>}
                    </Container>
                </div>
                }
               
            </form>
        );
    }
}

const actions = (dispatch: Dispatch) => ({
    addUser: (data: any) => dispatch({ type: ADD_USER, payload: data }),
    updateUser: (data: any) => dispatch({ type: UPDATE_USER, payload: data }),
    authorizeUser: (data:any) => dispatch({type: AUTHORIZE_USER, payload: data})
});
export default connect(null, actions)(withStyles(styles)(UserForm));